import React, { Suspense } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Suspense wrapper for lazy-loaded components
 * @param {Object} props
 * @param {React.Component} props.children - Lazy loaded component
 * @param {string} props.fallbackMessage - Loading message
 */
const PageSuspense = ({ children, fallbackMessage = "Loading..." }) => {
  const LoadingFallback = () => (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="400px"
      gap={2}
    >
      <CircularProgress size={40} />
      <Typography variant="body2" color="textSecondary">
        {fallbackMessage}
      </Typography>
    </Box>
  );

  return (
    <Suspense fallback={<LoadingFallback />}>
      {children}
    </Suspense>
  );
};

export default PageSuspense;